var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCategoryCovericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 230,
    viewBox: "0 0 160 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_8908)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 230,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 160,
    height: 230,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 160,
    height: 230,
    fill: "url(#paint0_linear_1330_8908)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8694 52.7981C87.7556 51.7908 93.6417 51.7188 99.275 52.5103C99.275 45.6748 99.275 38.8393 99.275 31.9679C97.8667 31.716 96.4583 31.5362 95.0139 31.3923C95.0139 36.7527 95.0139 42.0772 95.0139 47.4377C90.7167 47.1498 86.3111 47.3657 81.9056 48.0852C81.9056 47.1498 81.9056 46.2145 81.9056 45.2791C85.3361 44.6675 88.7667 44.3797 92.1611 44.3797C92.1611 41.9333 92.1611 39.5229 92.1611 37.0765C88.7667 37.0405 85.3722 37.2924 81.9056 37.868C81.9056 36.9326 81.9056 35.9972 81.9056 35.0618C85.3361 34.4502 88.7667 34.1624 92.1611 34.1624C92.1611 31.752 92.1611 29.3056 92.1611 26.8952C88.7667 26.8592 85.3722 27.1111 81.9056 27.6867C81.9056 26.7513 81.9056 25.8159 81.9056 24.8806C86.3111 24.1251 90.7167 23.8372 95.0139 24.0891C95.0139 25.4562 95.0139 26.7873 95.0139 28.1544C97.3972 28.3703 99.7806 28.766 102.092 29.3056C102.092 38.1918 102.092 47.0779 102.092 55.964C95.6278 54.7408 88.7667 54.7768 81.9056 56C81.8694 54.9567 81.8694 53.8774 81.8694 52.7981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 55.964C58 47.0779 58 38.1918 58 29.3056C60.3111 28.766 62.6583 28.4062 65.0778 28.1544C65.0778 26.7873 65.0778 25.4562 65.0778 24.0891C69.375 23.8372 73.7806 24.1251 78.1861 24.8806C78.1861 25.8159 78.1861 26.7513 78.1861 27.6867C74.7556 27.1111 71.325 26.8592 67.9306 26.8952C67.9306 29.3056 67.9306 31.752 67.9306 34.1624C71.325 34.1624 74.7194 34.4502 78.1861 35.0618C78.1861 35.9972 78.1861 36.9326 78.1861 37.868C74.7556 37.2924 71.325 37.0405 67.9306 37.0765C67.9306 39.5229 67.9306 41.9333 67.9306 44.3797C71.325 44.3797 74.7194 44.6675 78.1861 45.2791C78.1861 46.2145 78.1861 47.1498 78.1861 48.0852C73.7806 47.3657 69.375 47.1498 65.0778 47.4377C65.0778 42.0772 65.0778 36.7527 65.0778 31.3923C63.6333 31.5362 62.225 31.716 60.8167 31.9679C60.8167 38.8034 60.8167 45.6388 60.8167 52.5103C66.45 51.7188 72.3 51.7908 78.2222 52.7981C78.2222 53.8774 78.2222 54.9567 78.2222 56C71.325 54.7768 64.4639 54.7768 58 55.964Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 24,
    y: 88,
    width: 112,
    height: 15,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 54,
    y: 115,
    width: 53,
    height: 6,
    rx: 3,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1330_8908",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229343,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_8908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 230,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCategoryCovericon);
export default __webpack_public_path__ + "static/media/no-category-cover.icon.f22a5ac8c0c59fd1b217558412bf30f2.svg";
export { ForwardRef as ReactComponent };